<app-navbar></app-navbar>
<div class="main-container">
    <div class="background">
        <!-- <div *ngIf="!isMap" class="top"></div> -->
    </div>
    <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!isMap"></app-footer>
